import type { UpcomingInvoicesReportItem } from '@vy/types';
import { sumBy, uniqueBy } from '@vy/utils';
import { sortBy } from 'lodash';
import { getMaxDate, getMinDate, toMonthStart } from '../../../../../utils/date';
import { buildMonthKey } from './billing-forecast-report-aggregator';

export function getTotalBillingForecastDateHeaders(
  reportItems: UpcomingInvoicesReportItem[],
): string[] {
  const monthKeys: string[] = [];

  for (const item of reportItems) {
    for (const invoice of item.invoices) {
      monthKeys.push(buildMonthKey(invoice.invoicingDate));
    }
  }

  const uniqueMonthKeys = uniqueBy(monthKeys, (monthKey) => monthKey);

  return sortBy(uniqueMonthKeys, (monthKey) => parseBillingForecastMonthKey(monthKey));
}

export function parseBillingForecastMonthKey(monthKey: string): Date {
  return new Date(monthKey + ' 1');
}

export function filterBillingForecastDateHeaders(
  allDateHeaders: string[],
  fromDate?: Date | null,
  toDate?: Date | null,
): string[] {
  const rangeStart = fromDate ? toMonthStart(fromDate) : getMinDate();
  const rangeEnd = toDate ? toMonthStart(toDate) : getMaxDate();

  return allDateHeaders.filter((header) => {
    const headerDate = parseBillingForecastMonthKey(header);
    return headerDate >= rangeStart && headerDate <= rangeEnd;
  });
}

export function computeMonthlyGrandTotal(
  reportItems: UpcomingInvoicesReportItem[],
  monthKey: string,
): number {
  return sumBy(reportItems, (item) => {
    return sumBy(
      item.invoices.filter((invoice) => buildMonthKey(invoice.invoicingDate) === monthKey),
      (invoice) => invoice.total,
    );
  });
}
